import React,{useEffect, useState} from "react";
import SmallFooter from "../componants/footer/smallFooter";
import ScrollTop from "../componants/scrollTop";
import PersonalNavbarPages from "./navbar/personalNavbarPages";

export default function LegalNotice(){
    return(
        <>
        <PersonalNavbarPages items={[{titulo:'Aviso Legal', 'id':'avisoLegal'}]} />

        <section className="section mt-5" id="avisoLegal" style={{ paddingTop:'1rem' }}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title mb-4">
                            <h4 className="title mb-4"><br/>AVISO LEGAL</h4>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-12">
                        <h5>Pilates Rizzo S.L.</h5>
                        <p>Fecha de última actualización: 25/01/2025</p>
                        <h5>1. Titular del sitio web</h5>
                        <p style={{textAlign:'justify'}}>
                            En cumplimiento con el deber de información recogido en la Ley 34/2002, de 11 de
                            julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-
                            CE), se informa que esta página web es titularidad de:
                        </p>
                        <ul>
                            <li style={{display:'none'}}></li>
                            <li><span className="h6">Nombre del Centro:</span> Pilates Rizzo</li>
                            <li><span className="h6">NIF/CIF:</span> B72643638</li>
                            <li><span className="h6">Domicilio social:</span> Calle Téllez 17, 4º C, Madrid 28007</li>
                            <li><span className="h6">Correo electrónico:</span> info@platesrizzo.com</li>
                            <li><span className="h6">Teléfono de contacto:</span> 623255264</li>
                        </ul>
                        <h5>2. Condiciones de uso</h5>
                        <p style={{textAlign:'justify'}}>
                            El acceso y la utilización de esta página web atribuyen la condición de usuario, lo que
                            implica la aceptación de las condiciones de uso aquí reflejadas. Si no estás de
                            acuerdo con alguna de estas condiciones, debes abstenerte de utilizar este sitio web.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            El usuario se compromete a hacer un uso adecuado de los contenidos y servicios que
                            ofrece Pilates Rizzo, y a no emplearlos para incurrir en actividades ilícitas, ilegales o
                            contrarias a la buena fe y al orden público.
                        </p>
                        <h5>3. Propiedad intelectual e industrial</h5>
                        <p style={{textAlign:'justify'}}>
                            Todos los contenidos del sitio web, incluyendo textos, imágenes, diseño gráfico, logos,
                            iconos, código fuente y demás elementos, son propiedad del titular o de terceros que
                            han autorizado su uso, estando protegidos por la normativa de propiedad intelectual e
                            industrial.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            Queda prohibida su reproducción, distribución, comunicación pública o cualquier otra
                            forma de explotación sin la autorización previa y por escrito del titular.
                        </p>
                        <h5>4. Responsabilidad</h5>
                        <p style={{textAlign:'justify'}}>
                            El titular del sitio web no se hace responsable de los daños o perjuicios que pudieran
                            derivarse del uso indebido de los contenidos del sitio. Tampoco garantiza la
                            disponibilidad continua del sitio web ni la ausencia de errores en el acceso, aunque
                            realizará los esfuerzos necesarios para corregirlos cuando sea posible.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            El sitio web puede contener enlaces a páginas externas, no siendo responsable el
                            titular de los contenidos ni de las condiciones de uso de dichas páginas.
                        </p>
                        <h5>5. Protección de datos personales</h5>
                        <p style={{textAlign:'justify'}}>
                            El tratamiento de los datos personales de los usuarios se regirá por lo establecido en
                            nuestra Política de Privacidad, donde se detalla cómo recopilamos, utilizamos y
                            protegemos tu información personal.
                        </p>
                        <h5>6. Legislación aplicable y jurisdicción</h5>
                        <p style={{textAlign:'justify'}}>
                            Las presentes condiciones se rigen por la legislación española. Para la resolución de
                            cualquier controversia que pudiera derivarse del acceso o uso de este sitio web, las
                            partes se someterán a los juzgados y tribunales del domicilio del titular del sitio web,
                            salvo que la ley disponga lo contrario.
                        </p>
                        <h5>Pilates Rizzo S.L.</h5>
                        <h5>25/01/2025</h5>
                    </div>
                </div>
            </div>
        </section>

        <SmallFooter/>
        <ScrollTop/>

        </>
    )
}

// rosa: #dacbd2
// lila: #735fb3
// verde: #bdcec8
